import { render, staticRenderFns } from "./UserAgreement.vue?vue&type=template&id=73cb54c4&scoped=true"
import script from "./UserAgreement.vue?vue&type=script&lang=js"
export * from "./UserAgreement.vue?vue&type=script&lang=js"
import style0 from "./UserAgreement.vue?vue&type=style&index=0&id=73cb54c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cb54c4",
  null
  
)

export default component.exports